'use_strict'

import session from "./session"
import format from 'string-format'

export default {
	storage_list() {
		return session.get('storage/')
	},

	load_storage_tree(storage_id) {
		return session.get(format(
			'storage/{storage_id}/storage_tree/',
			{storage_id: storage_id,}))
	},
}
